import React from 'react';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

import general from '../../modulos/general';

import _ from 'lodash';

const ImprPS = (idLista, empresa, fechaHoraHoy) => {
  // console.log(idLista, empresa)

  //GENERAR PDF
  let doc = new jsPDF({orientation: 'p', unit: 'mm', format: 'letter'})

  let widthDoc = (doc.internal.pageSize.width)

  let linea1DNN = ""
  let linea2DNN = ""
  if(idLista.direccion.descrTipoVia1){
    linea1DNN = idLista.direccion.descrTipoVia1?idLista.direccion.descrTipoVia1:""
    linea1DNN += idLista.direccion.numeroTipoVia1?" " + idLista.direccion.numeroTipoVia1:""
    linea1DNN += idLista.direccion.descrTipoVia2?" " + idLista.direccion.descrTipoVia2:""
    linea1DNN += idLista.direccion.numeroTipoVia2?" " + idLista.direccion.numeroTipoVia2:""
    linea1DNN += idLista.direccion.numeroTipoVia2F?" " + idLista.direccion.numeroTipoVia2F:""
    linea1DNN += idLista.direccion.descrTipoUnd1?" " + idLista.direccion.descrTipoUnd1:""
    linea1DNN += idLista.direccion.numeroTipoUnd1?" " + idLista.direccion.numeroTipoUnd1:""
    linea1DNN += idLista.direccion.descrTipoUnd2?" " + idLista.direccion.descrTipoUnd2:""
    linea1DNN += idLista.direccion.numeroTipoUnd2?" " + idLista.direccion.numeroTipoUnd2:""
    linea1DNN = linea1DNN.substr(0, 40)
    
    linea2DNN = idLista.dirmayor.ciudades.nombreCiudad?idLista.dirmayor.ciudades.nombreCiudad:""
    linea2DNN += idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio?" - " + idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio:""
    linea2DNN = linea2DNN.substr(0, 40)
  }
  let nombreCli = `${idLista.nombreCliente} ${idLista.apellidoCliente}`
  let nitcc = idLista.numeroDoc?idLista.numeroDoc:""

  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaHoy = fechaHoraHoy.substr(11, 8)

// console.log(linea1DNN, linea2DNN, nombreCli, nitcc)

  let letvRC = 0

  doc.setFontSize(14);
  doc.setFontType("bold");
  doc.setFontStyle("italic");
  doc.text(empresa.empresaRazonSocial, widthDoc/1.9, letvRC+17, 'center')
  
  doc.setFontSize(10);
  doc.setFontType("normal");
  doc.text(`NIT. ${empresa.empresaNit}`, widthDoc/1.9, letvRC+22, 'center')
  doc.text(`${empresa.empresaDir} ${empresa.empresaTel}`, widthDoc/1.9, letvRC+27, 'center')

  doc.setFontSize(16);
  doc.setFontType("bold");
  doc.text("P A Z    Y    S A L V O", widthDoc/1.9, letvRC+47, 'center')

  doc.setFontSize(8);
  doc.setFontType("normal");
  doc.text("FECHA:", 20, letvRC+67,)
  doc.text(`${fechaHoy} ${horaHoy}`, 50, letvRC+67,)
  doc.text(`CLIENTE:`, 20, letvRC+72)
  doc.text(`${idLista.contrato}   ${nombreCli}`, 50, letvRC+72)
  doc.text(`CEDULA / NIT:`, 20, letvRC+77)
  doc.text(`${nitcc}`, 50, letvRC+77)
  doc.text(`DIRECCION:`, 20, letvRC+82)
  doc.text(`${linea1DNN}`, 50, letvRC+82)
  doc.text(`${linea2DNN}`, 50, letvRC+87)
  doc.text("SALDO A LA FECHA:", 20, letvRC+92)
  doc.text(`$${general.formatNum(idLista.saldoPendiente.toString())}`, 50, letvRC+92)

  doc.line(20, letvRC+140, 100, letvRC+140)
  doc.text("FIRMA Y SELLO", 45, letvRC+145)


  // let nameDoc = `OS-${listOS.numeroOS}.pdf`
  doc.autoPrint({variant: 'non-conform'});
  // doc.output('dataurlnewwindow'); //abre el pdf en una nueva ventana // OJOOO YA NO FUNCIONA
  // => UTILIZAR
  const pdfBlob = doc.output('blob');
  const url = URL.createObjectURL(pdfBlob);
  window.open(url);
  // doc.save(nameDoc)
}

export default ImprPS